import { apiClient } from './client';
export const leadsApi = {
    getCampaignLeads: (campaignId, workspaceId, signal) => {
        const url = `/api/Workspaces/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/Leads`;
        return apiClient.get(url, { signal });
    },
    getWebLeads: (campaignId, workspaceId, webId, signal) => {
        const url = `/api/Workspaces/${encodeURIComponent(workspaceId)}/Campaigns/${encodeURIComponent(campaignId)}/Webs/${encodeURIComponent(webId)}/Leads`;
        return apiClient.get(url, { signal });
    },
    getWorkspaceLeads: (workspaceId, signal) => {
        const url = `/api/Workspaces/${encodeURIComponent(workspaceId)}/Leads`;
        return apiClient.get(url, { signal });
    },
    update: (workspaceId, campaignId, leadId, payload, signal) => {
        return apiClient.put(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Leads/${leadId}/Update`, payload, { signal });
    },
    enrichPhone: (workspaceId, campaignId, leadId, signal) => {
        return apiClient.post(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Leads/${leadId}/EnrichPhone`, {}, { signal });
    },
    syncPhone: (workspaceId, campaignId, leadId, signal) => {
        return apiClient.post(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Leads/${leadId}/SyncPhone`, {}, { signal });
    },
    reEnrich: (workspaceId, campaignId, leadId, signal) => {
        return apiClient.post(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Leads/${leadId}/re-enrich`, {}, { signal });
    },
    updateWebSourceAttribution: (workspaceId, campaignId, leadId, webId, payload, signal) => {
        return apiClient.patch(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Leads/${leadId}/WebSourceAttributions/${webId}`, payload, { signal });
    },
    delete: (workspaceId, campaignId, leadId, signal) => {
        return apiClient.delete(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Leads/${leadId}`, { signal });
    },
    /**
     * Search for leads to merge with
     */
    searchForMerge: (workspaceId, campaignId, params, signal) => {
        const queryParams = new URLSearchParams();
        if (params.firstName)
            queryParams.append('firstName', params.firstName);
        if (params.lastName)
            queryParams.append('lastName', params.lastName);
        if (params.email)
            queryParams.append('email', params.email);
        if (params.companyName)
            queryParams.append('companyName', params.companyName);
        if (params.linkedInUrn)
            queryParams.append('linkedInUrn', params.linkedInUrn);
        if (params.excludeId)
            queryParams.append('excludeId', params.excludeId);
        return apiClient.get(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Leads/search-for-merge?${queryParams.toString()}`, { signal });
    },
    /**
     * Merge two leads
     */
    merge: (workspaceId, campaignId, request, signal) => {
        return apiClient.post(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/Leads/merge`, request, { signal });
    }
};
